module.exports = {"653129100":"巴仁镇","653129101":"西克尔库勒镇","653129102":"夏普吐勒镇","653129103":"卧里托格拉克镇","653129104":"克孜勒博依镇","653129107":"和夏阿瓦提镇","653129200":"铁日木乡","653129201":"英买里乡","653129202":"江巴孜乡","653129205":"米夏乡","653129208":"克孜勒苏乡","653129209":"古勒鲁克乡","653129210":"玉代克力克乡","653129500":"兵团伽师总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653129.json
// module id = 3114
// module chunks = 0